<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerText]="T.ABOUT_DIALOG_ABOUT_SIMSTATION | translate"
	[matDialogData]="data"
	[rect]="rect"
	[headerIcon]="{fontIcon: 'fa-info-circle', fontSet: 'fas'}"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<div class="systemInformationContainer">
			<div class="systemInformationEntry version">
				<div class="systemInformationEntryTitle">
					<h2 class="mat-h3 nomargin">{{ T.ABOUT_DIALOG_VERSION | translate }}:</h2>
				</div>
				<div class="systemInformationEntryValue">
					{{ version }}
				</div>
			</div>
			<div class="systemInformationEntry version">
				<div class="systemInformationEntryTitle">
					<h2 class="mat-h3 nomargin">{{ T.ABOUT_DIALOG_LAST_UPDATE | translate }}:</h2>
				</div>
				<div class="systemInformationEntryValue">
					{{ lastUpdate | date: (T.DATE_FORMAT_ADMIN | translate) :'': translate.currentLang }}
				</div>
			</div>
			<div class="systemInformationEntry version">
				<div class="systemInformationEntryTitle">
					<h2 class="mat-h3 nomargin">{{ T.ABOUT_DIALOG_AVAILABLE_DISK_SPACE | translate }}:</h2>
				</div>
				<div class="systemInformationEntryValue">
					{{ availableFreeSpace }}
				</div>
			</div>
			<div class="systemInformationEntry version">
				<div class="systemInformationEntryTitle">
					<h2 class="mat-h3 nomargin">{{ T.ABOUT_DIALOG_SERVER_IP | translate }}:</h2>
				</div>
				<div class="systemInformationEntryValue">
					{{ serverIp }}
				</div>
			</div>
			@if (identifier?.ip) {
				<div class="systemInformationEntry version">
					<div class="systemInformationEntryTitle">
						<h2 class="mat-h3 nomargin">{{ T.VERSION_DIALOG_CLIENT_IP | translate }}:</h2>
					</div>
					<div class="systemInformationEntryValue">
						{{ identifier?.ip }}
					</div>
				</div>
			}
			@if (identifier?.deviceId) {
				<div class="systemInformationEntry version">
					<div class="systemInformationEntryTitle">
						<h2 class="mat-h3 nomargin">{{ T.VERSION_DIALOG_DEVICE_ID | translate }}:</h2>
					</div>
					<div class="systemInformationEntryValue">
						{{ identifier?.deviceId }}
					</div>
				</div>
			}
			@if (identifier?.macAddress) {
				<div class="systemInformationEntry version">
					<div class="systemInformationEntryTitle">
						<h2 class="mat-h3 nomargin">{{ T.VERSION_DIALOG_MAC_ADDR | translate }}:</h2>
					</div>
					<div class="systemInformationEntryValue">
						{{ identifier?.macAddress }}
					</div>
				</div>
			}
			<div class="systemInformationEntry version">
				<div class="systemInformationEntryTitle">
					<h2 class="mat-h3 nomargin">{{ T.ABOUT_DIALOG_CLIENT_TYPE | translate }}:</h2>
				</div>
				<div class="systemInformationEntryValue">
					@if (clientProperties().isRecorder) {
						<div class="clientType">
							<span class="info">{{ T.VERSION_DIALOG_RECORDER | translate }} {{ clientProperties().recorder.name }}</span>
						</div>
					}
					@if (clientProperties().isTablet) {
						<div class="clientType">
							<span class="info">{{ T.VERSION_DIALOG_TABLET | translate }} {{ clientProperties().tablet.name }}</span>
						</div>
					}
					@if (clientProperties().isViewingStation) {
						<div class="clientType">
							<span class="info"
								>{{ T.VERSION_DIALOG_VIEWING_STATION | translate }} {{ clientProperties().viewingStation.name }}</span
							>
						</div>
					}
				</div>
			</div>
			<div class="systemInformationEntry version">
				<div class="systemInformationEntryTitle">
					<h2 class="mat-h3 nomargin">{{ T.ABOUT_DIALOG_WEB_SOCKET_ID | translate }}:</h2>
				</div>
				<div class="systemInformationEntryValue">
					{{ webSocketId }}
				</div>
			</div>

			<div class="systemInformationEntry version">
				<div class="systemInformationEntryTitle">
					<h2 class="mat-h3 nomargin">
						{{ T.SYSTEM_TYPE | translate }}
					</h2>
				</div>
				<div class="systemInformationEntryValue">
					{{ Scope[SimConfigurationService.settings.license.scope] }}
				</div>
			</div>
			<div class="systemInformationEntry version">
				<div class="systemInformationEntryTitle">
					<h2 class="mat-h3 nomargin">
						{{ T.ACTIVATED_MODULES | translate }}
					</h2>
				</div>
				<div class="systemInformationEntryValue">
					@for (module of allModules; track module) {
						<div [class.nonHostThenHide]="!simUserService.user.isHost" [class.notLicensed]="!hasLicenseModule(Modules[module])">
							{{ "LICENSE_MODULES_" + module.toUpperCase() | translate }}
						</div>
					}
				</div>
			</div>
		</div>
	</ng-container>
</sim-basic-material-dialog>
